import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Beginner's Guide to Setting Up FTP Accounts in cPanel on Namecheap Hosting
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

               <img src="/graphics/images/FTP.webp" alt="FTP" />

                
                <p>
          If you’re new to website management, setting up an FTP account might sound technical. But with the right guidance, it’s a straightforward process that gives you more control over your website files. In this beginner-friendly guide, we’ll walk you through everything you need to know about setting up FTP accounts in cPanel, specifically for websites hosted with Namecheap hosting.
        </p>

                <h2>What is FTP?</h2>
                <p>
          FTP stands for File Transfer Protocol. It’s a standard method for transferring files between your local computer and a remote server. Using an FTP client like FileZilla, you can upload, edit, and manage files on your web server without logging into cPanel every time.
                </p>
        
        <p>It’s a useful tool for website owners, developers, and anyone who needs to manage or update website files. With FTP, you can organize your files directly on the server, making it easier to update your website, back up important data, or troubleshoot problems. To use FTP, you typically need an FTP client (such as FileZilla), an FTP server address, a username, and a password to connect to the server.</p>
        
        <p>FTP is widely used because it’s reliable and works with most hosting services, although many people now use secure versions of FTP, like SFTP (Secure File Transfer Protocol) or FTPS (FTP Secure), which add encryption to protect data during transfer.</p>
        
        <img src="/graphics/images/FTP_process.webp" alt="FTP" />
        
        <p>After logging into your cPanel account, you'll see your cPanel dashboard. follow these steps:</p>
        
        <ol>
        <li>Locate the File Section:<br/>&nbsp; Scroll down to find the "File" section on the dashboard.</li>
                <img src="/graphics/images/ftp_dashboard.webp" alt="FTP" />
        <li>Click on "FTP Accounts":<br/>&nbsp; This will take you to a screen where you can see a form to Add new ftp account.</li>
        <img src="/graphics/images/ftpaccount.webp" alt="FTP" />
        <li>Create a New FTP Account:<br/>&nbsp;Fill your new FTP account detail and select the domain or subdomain for which you want to create an FTP account. you can mention the directory name in which ftp account will be created.</li>
        
        
        <p>Login: Enter the desired username for your FTP account. This will be combined with your main domain to form the full username (e.g., username@yourdomain.com).</p>

        <p>Domain: Select the domain you want to associate with this FTP account from the dropdown menu.</p>

        <p>Password: Enter a strong password. You can use the "Password Generator" for a secure password.</p>

        <p>Password (Again): Re-enter the password to confirm.</p>

        <p>Directory: Specify the directory this FTP account will have access to. By default, cPanel suggests a directory based on the username. You can modify this to grant access to a specific folder.</p>

        <p>Quota: Set the disk space limit for this FTP account or choose "Unlimited."</p>
        
        <img src="/graphics/images/ftp_details.webp" alt="FTP" />
        
        <li>Click on FTP "Create FTP Account":<br/>&nbsp; After filling the details of the new FTP account now you click on Create FTP Account button for creating new FTP.</li>
        
        <img src="/graphics/images/create_ftp.webp" alt="FTP" /> 
        
        <li>FTP Account lisitng:<br/>&nbsp; Your new FTP account will now appear under the "FTP Accounts" section, where you can manage it further if needed.</li>
        
        <img src="/graphics/images/ftplist.webp" alt="FTP" /> 
        </ol>
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
